module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAT1JREFUOBGl1dENgjAQBmBaFlAncAMNDKBuoBMYH3xyGH3y2U1kAoILOIJxAdD/R0uw2vbAS4w2LZ/X3jWoKSKO431ZlquiKO7RH5Gm6emByPN8o5IkyZRSM3gF8EVfnCiMNfOio6uqWuJPLhgz8zM2MOBkl2ijsDZILlMEiGmtmfkEw06Z2yiO4USzhvmjD+5CP+CuuA/9gqV4CP0Jh3AJ6oRdOLrmgLm6pVh9Uyiut6Mpnj3BsVXQG7AROicKoXzWC7fwK8AhwAh9v0OfHjnnC+2b5Nx7+zXKbDHeSi6RFzaFIshMkbH4hjphgzJrnim3D3wuxX+esY22q28V1Hn9v2AfyuwZEvwDlqAvOow3cBdUgtdwHzSEq39QH67RPhkXsKXa1TcPSb75OjOtCKc5XlZ5LAFCa9gt/HDdEzLDQ6XZjBBQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/close.png
// module id = 605
// module chunks = 0